type Color = 'good' | 'bad' | 'brand01' | 'darkerGray';

export const getKeyMetricColor = (value?: number | null): Color => {
  if (value === undefined) {
    return 'brand01';
  }
  if (value === 0 || value === null) {
    return 'darkerGray';
  }
  if (value < 0) {
    return 'bad';
  }
  return 'good';
};
